import Apis from "../../config/Apis";
import Axios from "../../config/Axios";
import { headers } from "../../utills";
import {
  get_notifications,
  hideLoading,
  reset_notifications,
  showAlert,
  showLoading,
} from "../Actions/GeneralActions";
import { lotNumberData, pagesData } from "../Actions/PagesAction";

export const PagesMiddleware = {
  getPages: (params) => {
    return (dispatch) => {
      //   dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await Axios.get(
            Apis.pages(params?.role || "dealership"),
            headers.config(),
          );
          // console.log("paaaaaaaaaaaages", data.data);
          if (data?.success) {
            resolve(data?.data);
            dispatch(pagesData(data?.data));
          } else {
            reject(data?.data);
            dispatch(showAlert({ type: "error", message: data?.message }));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },

  get_Notification: ({ url }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          if (url == undefined) {
            if (url) {
            } else {
              dispatch(reset_notifications());
            }
          }
          const data = await Axios.get(
            Apis.notifications(url),
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(true);
            // console.log("data///////", data);

            dispatch(get_notifications(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "Get Notification",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  lotnumber: (params) => async (dispatch) => {
    dispatch(showLoading());

    try {
      const formdata = new FormData();
      formdata.append("name", params.payload?.name);
      formdata.append("address", params.payload?.address);
      if (params.payload?.id) {
        formdata.append("id", params.payload?.id);
      }

      const config = {
        method: params.method,
        url:
          params.url ||
          Apis.lockdown(
            params.params?.name
              ? `${params.route}?lot_no=${params.params.name}`
              : params.route,
          ),
        headers: headers.config()?.headers,
      };

      if (params.method !== "get") {
        config.data = formdata;
      }

      const { data } = await Axios(config);

      if (data?.success) {
        dispatch(lotNumberData(data.data));
        return data.data;
      }

      dispatch(
        showAlert({
          type: "error",
          message: data?.message,
        }),
      );
    } catch (error) {
      dispatch(
        showAlert({
          title: "lotNumber",
          message: error?.response?.data?.message || error.message,
          type: "Error",
          status: error?.response?.status,
        }),
      );

      throw error;
    } finally {
      dispatch(hideLoading());
    }
  },
};
